import actionTypes from '../actions/actionTypes';

const initContentOfConfirmModal = {
    isOpen: false,
    messageId: "",
    handleFunc: null,
    dataFunc: null
}

const initialState = {
    started: true,
    language: 'vi',
    isShowChatbot: 'false',
    systemMenuPath: '/system/user-manage',
    contentOfConfirmModal: {
        ...initContentOfConfirmModal
    }
}

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.APP_START_UP_COMPLETE:
            return {
                ...state,
                started: true
            }
        case actionTypes.SET_CONTENT_OF_CONFIRM_MODAL:
            return {
                ...state,
                contentOfConfirmModal: {
                    ...state.contentOfConfirmModal,
                    ...action.contentOfConfirmModal
                }
            }

        case actionTypes.CHANGE_LANGUAGE:
            // console.log('check redux', action);
            return {
                ...state,
                language: action.language,
            }
        case actionTypes.SHOW_CHATBOT:
            // console.log('check redux', action);
            return {
                ...state,
                isShowChatbot: action.isShowChatbot,
            }

        default:
            return state;
    }
}

export default appReducer;